import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useReviewRatingApi } from '../../store/api/hooks/reviewratingApiHook';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';
import { ReviewStatProps } from '../../_config/interfaces/interfaces';


const ReviewStat: React.FC<ReviewStatProps> = ({ filterValue }) => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [reviewSummary, setReviewSummary] = useState<any>({});

    const branchDS = useStoreBrnDSSelector();
    const reviewAPI = useReviewRatingApi();;

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue);
        } else {
            getReviewSummary({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        // console.log('filterValue =>', filterValue); 
        getReviewSummary(filterValue);
    }

    const getReviewSummary = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                reviewAPI.getReviewSummary(params, (msg: any, resp: any) => {
                    setReviewSummary(resp.data);

                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                });
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    const positive = reviewSummary.sentiment_breakdown?.positive?.percentage ?? 0;
    const neutral = reviewSummary.sentiment_breakdown?.neutral?.percentage ?? 0;
    const negative = reviewSummary.sentiment_breakdown?.negative?.percentage ?? 0;
    const mixed = reviewSummary.sentiment_breakdown?.mixed?.percentage ?? 0;

    let positiveWidth: any = 0;
    let negativeWidth: any = 0;
    let neutralWidth: any = 0;
    let mixedWidth: any = 0;
    let positiveCount: any = reviewSummary.sentiment_breakdown?.positive?.count ?? 0;
    let negativeCount: any = reviewSummary.sentiment_breakdown?.negative?.count ?? 0;
    let neutralCount: any = reviewSummary.sentiment_breakdown?.neutral?.count ?? 0;
    let mixedCount: any = reviewSummary.sentiment_breakdown?.mixed?.count ?? 0;

    const totalSentiment = positive + neutral + negative + mixed;

    if (totalSentiment > 0) {
        positiveWidth = (positive / totalSentiment) * 100;
        neutralWidth = (neutral / totalSentiment) * 100;
        negativeWidth = (negative / totalSentiment) * 100;
        mixedWidth = (mixed / totalSentiment) * 100;
    }

    const renderStars = (rating: any) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <Icon
                    key={i}
                    name="full-star"
                    size={22}
                    className={`mr-1 ${i < Math.floor(rating) ? 'text-yellow-400' : 'text-gray-300'}`}
                />
            );
        }
        return stars;
    };

    return (
        <div className="flex flex-col">
            <h1 className="text-xl font-semibold text-gray-600 mb-4">Stats</h1>

            {/* Paragraph */}
            {/* <p className="text-sm text-gray-600 mb-6">
                Not Matching The Public Store? You're Probably Looking For <span className='text-sm text-yellow-500 font-semibold'>Ratings</span>
            </p> */}
            <hr />

            {/* Main Content */}
            <div className="flex justify-between mobile-column">
                {isOnSubmitLoading && (
                    <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                        <Spinner className="self-center z-50" />
                    </div>
                )}
                <div className="w-1/2 p-4 border-r border-gray-200 flex flex-col relative mobile-width-100 mobile-border-0">
                    <div className='flex mb-4 items-center'>
                        <h1 className="text-sm font-semibold text-gray-600">Reviews</h1>
                        <div className="pointer-events-auto relative ml-1">
                            <Icon name="info" size={20} className="text-gray-400" tooltipText="Total number of customer reviews received within the selected date range" width="w-56" />
                        </div>
                    </div>

                    <div className="relative flex flex-col items-center justify-center mt-6">
                        <p className="bg-yellow-200 rounded-full w-32 h-32 flex items-center justify-center text-lg font-semibold text-gray-600 mb-6">
                            {reviewSummary?.total_reviews}
                        </p>
                        <p className="text-sm font-semibold text-gray-400 mb-6">For Selected Range</p>
                        <p className="text-sm font-semibold text-gray-400 mb-6">{`(Total Review ${reviewSummary?.gross_total_reviews})`}</p>
                    </div>
                </div>

                <div className="w-1/2 p-4 border-r border-gray-200 relative mobile-width-100 mobile-border-0">
                    <div className='flex mb-4 items-center'>
                        <h1 className="text-sm font-semibold text-gray-600">Avg Stars</h1>
                        <div className="pointer-events-auto relative ml-1">
                            <Icon name="info" size={20} className="text-gray-400" tooltipText="Average star rating calculated from all customer reviews in the selected period" width="w-56" />
                        </div>
                    </div>

                    {/* <Icon name="info" size={20} className="absolute left-[84px] top-[26px] transform -translate-y-1/2 text-gray-400 pointer-events-auto" /> */}
                    <div className="flex mb-2">
                        {renderStars(reviewSummary?.average_rating)}
                    </div>
                    <p className="text-lg font-semibold text-gray-600 mb-6">{reviewSummary?.average_rating ?? 0} Stars</p>
                </div>

                <div className="w-1/2 p-4 border-r border-gray-200 relative mobile-width-100 mobile-border-0">
                    <div className='flex mb-4 items-center'>
                        <h1 className="text-sm font-semibold text-gray-600">Stars Breakdown</h1>
                        <div className="pointer-events-auto relative ml-1">
                            <Icon name="info" size={20} className="text-gray-400" tooltipText="Distribution of reviews across 1 to 5 star ratings showing count for each" width="w-56" />
                        </div>
                    </div>


                    {/* <Icon
                        name="info"
                        size={20}
                        className="absolute right-[125px] top-[26px] transform -translate-y-1/2 text-gray-400 pointer-events-auto"
                    /> */}
                    {Array.from({ length: 5 }, (_, index) => {
                        let starRating;

                        switch (index) {
                            case 0:
                                starRating = reviewSummary?.rating_breakdown?.[5];
                                break;
                            case 1:
                                starRating = reviewSummary?.rating_breakdown?.[4];
                                break;
                            case 2:
                                starRating = reviewSummary?.rating_breakdown?.[3];
                                break;
                            case 3:
                                starRating = reviewSummary?.rating_breakdown?.[2];
                                break;
                            case 4:
                                starRating = reviewSummary?.rating_breakdown?.[1];
                                break;
                            default:
                                starRating = 0;
                                break;
                        }

                        const oneStars = reviewSummary?.rating_breakdown?.[1] ?? 0;
                        const twoStars = reviewSummary?.rating_breakdown?.[2] ?? 0;
                        const threeStars = reviewSummary?.rating_breakdown?.[3] ?? 0;
                        const fourStars = reviewSummary?.rating_breakdown?.[4] ?? 0;
                        const fiveStars = reviewSummary?.rating_breakdown?.[5] ?? 0;

                        const totalStars = oneStars + twoStars + threeStars + fourStars + fiveStars;
                        const progress = (starRating / totalStars) * 100;
                        const stars = Array.from({ length: 5 - index }, (_, i) => (
                            <Icon key={i} name="full-star" size={20} className="text-gray-300" />
                        ));

                        return (
                            <div key={index} className="flex flex-col items-center mb-4 w-full">
                                <div className="w-full bg-gray-300 rounded-full h-2 mb-2 overflow-hidden">
                                    <div
                                        className="h-2 bg-yellow-500 rounded-l-full"
                                        style={{ width: `${progress}%` }}
                                    ></div>
                                </div>

                                <div className="flex justify-between w-full">
                                    <div className="flex">
                                        {stars}
                                    </div>

                                    <span className="text-sm font-semibold text-gray-600">{starRating}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="w-1/2 p-4 relative mobile-width-100">
                    <div className='flex mb-4 items-center'>
                        <h1 className="text-sm font-semibold text-gray-600">Sentiment Breakdown</h1>
                        <div className="pointer-events-auto relative ml-1">
                            <Icon name="info" size={20} className="text-gray-400" tooltipText="AI-analyzed sentiment classification of reviews into Positive, Neutral, Mixed, or Negative categories" width="w-56" />
                        </div>
                    </div>

                    {/* <Icon
                        name="info"
                        size={20}
                        className="absolute right-[97px] top-[26px] transform -translate-y-1/2 text-gray-400 pointer-events-auto"
                    /> */}

                    <div className="mb-4">
                        <div className="w-full bg-gray-300 rounded-full h-2">
                            <div
                                className="h-2 bg-green-500 rounded-l-full"
                                style={{ width: `${positiveWidth}%` }}
                            ></div>
                        </div>
                        <div className="flex items-center mb-1">
                            <span className="text-sm text-gray-600 mr-2">Positive</span>
                            <span className="text-sm text-gray-600 ml-auto">{positiveCount} ({Math.round(positiveWidth)}%)</span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-full bg-gray-300 rounded-full h-2">
                            <div
                                className="h-2 bg-yellow-500"
                                style={{ width: `${neutralWidth}%` }}
                            ></div>
                        </div>
                        <div className="flex items-center mb-1">
                            <span className="text-sm text-gray-600 mr-2">Neutral</span>
                            <span className="text-sm text-gray-600 ml-auto">{neutralCount} ({Math.round(neutralWidth)}%)</span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-full bg-gray-300 rounded-full h-2">
                            <div
                                className="h-2 bg-yellow-500"
                                style={{ width: `${mixedWidth}%` }}
                            ></div>
                        </div>
                        <div className="flex items-center mb-1">
                            <span className="text-sm text-gray-600 mr-2">Mixed</span>
                            <span className="text-sm text-gray-600 ml-auto">{mixedCount} ({Math.round(mixedWidth)}%)</span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-full bg-gray-300 rounded-full h-2">
                            <div
                                className="h-2 bg-red-500 rounded-r-full"
                                style={{ width: `${negativeWidth}%` }}
                            ></div>
                        </div>
                        <div className="flex items-center mb-1">
                            <span className="text-sm text-gray-600 mr-2">Negative</span>
                            <span className="text-sm text-gray-600 ml-auto">{negativeCount} ({Math.round(negativeWidth)}%)</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}


export default ReviewStat;